import classNames from 'classnames';
import type { FullWidthProps, SharedComponentProps } from '../types';
import * as styles from './index.css';

type InputProps = SharedComponentProps<'input'> & FullWidthProps;

export function Input({ type = 'text', fullWidth, className, ...props }: InputProps) {
    return (
        <input
            type={type}
            className={classNames(styles.input, { [styles.fullWidth]: fullWidth }, className)}
            {...props}
        />
    );
}
